import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { TextResourceResolve } from './app/services/text-resource.resolve';
import { TextResourceService } from './app/services/text-resource.service';
import { ReferenceDataService } from './app/services/reference-data.service';
import { WindowRef } from './app/services/window-ref.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ZorroDateInterceptor } from './app/interceptors/zorro-date-interceptor';
import { FilterPipe } from './app/pipes/filter.pipe';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { ZorroClientModule } from '@zorro/apiclient';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';

const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: ZorroDateInterceptor, multi: true },
];



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, ZorroClientModule, ReactiveFormsModule),
        { provide: LOCALE_ID, useValue: "nl" },
        TextResourceResolve,
        TextResourceService,
        ReferenceDataService,
        WindowRef,
        httpInterceptorProviders,
        FilterPipe,
    ]
})
  .catch(err => console.error(err));
